import rolesEnum from '@/constant/rolesEnum'

export const MY_TEACHERS_PATH = '/my-teachers'

export const MY_TEACHERS_ACCESS_ROLES = [
  rolesEnum.admin,
  rolesEnum.juniorAdmin,
  rolesEnum.children,
  rolesEnum.parent,
  rolesEnum.seniorSeminarian,
]

export const MY_TEACHERS_MOCK_MENU_ITEM = {
  id: 'my-teachers-mock',
  title: 'Мои педагоги',
  url: MY_TEACHERS_PATH,
  icon: 'users',
}

export const MY_TEACHERS_SETTINGS_DEFAULTS = {
  disableMyTeachersMessagesForChildren: true,
  disableMyTeachersMessagesForParents: true,
  disableMyTeachersMessagesForEmployees: false,
}

const MY_TEACHERS_SETTINGS_STORAGE_KEY = 'my-teachers-mock-settings-v1'
const STUDENT_TEACHER_LESSON_TYPES = [
  'group',
  'private',
  'group_per_lesson',
  'lesson-payment',
]

export const MOCK_TEACHERS = [
  {
    id: 91001,
    name: 'Анна Викторовна Смирнова',
    role: rolesEnum.seminarian,
    avatar_path: null,
    about:
      'Помогаю понять математику через практику и наглядные примеры. Готовлю к ОГЭ и ЕГЭ.',
    userProfile: {
      sex: 'Female',
    },
    subjects: [
      { id: 101, name: 'Математика' },
      { id: 102, name: 'Подготовка к ЕГЭ' },
    ],
    mockRelations: {
      teachesMethodistCourse: true,
      studentLessonTypes: ['group'],
    },
  },
  {
    id: 91002,
    name: 'Михаил Андреевич Волков',
    role: rolesEnum.seminarian,
    avatar_path: null,
    about:
      'Преподаю английский язык, делаю упор на разговорную практику и уверенное использование грамматики.',
    userProfile: {
      sex: 'Male',
    },
    subjects: [
      { id: 201, name: 'Английский язык' },
      { id: 202, name: 'Разговорный английский' },
    ],
    mockRelations: {
      teachesMethodistCourse: true,
      studentLessonTypes: [],
    },
  },
  {
    id: 91003,
    name: 'Елена Сергеевна Кузнецова',
    role: rolesEnum.seminarian,
    avatar_path: null,
    about:
      'Объясняю физику без лишней теории и связываю каждую тему с задачами из реальной жизни.',
    userProfile: {
      sex: 'Female',
    },
    subjects: [{ id: 301, name: 'Физика' }],
    mockRelations: {
      teachesMethodistCourse: false,
      studentLessonTypes: ['private'],
    },
  },
  {
    id: 91004,
    name: 'Дмитрий Павлович Орлов',
    role: rolesEnum.seminarian,
    avatar_path: null,
    about:
      'Учу создавать первые проекты и разбираться в алгоритмах через понятные пошаговые задания.',
    userProfile: {
      sex: 'Male',
    },
    subjects: [
      { id: 401, name: 'Программирование' },
      { id: 402, name: 'Алгоритмы' },
    ],
    mockRelations: {
      teachesMethodistCourse: false,
      studentLessonTypes: ['lesson-payment'],
    },
  },
]

export const isMyTeachersRoleAllowed = (role) =>
  MY_TEACHERS_ACCESS_ROLES.includes(role)

export const getMockTeachersForRole = (role) => {
  if ([rolesEnum.admin, rolesEnum.juniorAdmin].includes(role)) {
    return MOCK_TEACHERS
  }

  if (role === rolesEnum.seniorSeminarian) {
    return MOCK_TEACHERS.filter(
      (teacher) => teacher.mockRelations.teachesMethodistCourse,
    )
  }

  if ([rolesEnum.children, rolesEnum.parent].includes(role)) {
    return MOCK_TEACHERS.filter((teacher) =>
      teacher.mockRelations.studentLessonTypes.some((lessonType) =>
        STUDENT_TEACHER_LESSON_TYPES.includes(lessonType),
      ),
    )
  }

  return []
}

const normalizeMockSettings = (settings = {}) =>
  Object.keys(MY_TEACHERS_SETTINGS_DEFAULTS).reduce(
    (result, key) => ({
      ...result,
      [key]: [true, 1, '1'].includes(settings?.[key])
        ? true
        : [false, 0, '0'].includes(settings?.[key])
          ? false
          : MY_TEACHERS_SETTINGS_DEFAULTS[key],
    }),
    {},
  )

export const getMyTeachersMockSettings = () => {
  if (typeof window === 'undefined') return MY_TEACHERS_SETTINGS_DEFAULTS

  try {
    const storedSettings = JSON.parse(
      window.localStorage.getItem(MY_TEACHERS_SETTINGS_STORAGE_KEY) || '{}',
    )

    return normalizeMockSettings(storedSettings)
  } catch {
    return MY_TEACHERS_SETTINGS_DEFAULTS
  }
}

export const saveMyTeachersMockSettings = (settings) => {
  const normalizedSettings = normalizeMockSettings(settings)

  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(
        MY_TEACHERS_SETTINGS_STORAGE_KEY,
        JSON.stringify(normalizedSettings),
      )
    } catch {
      // Настройки остаются в состоянии страницы, даже если storage недоступен.
    }
  }

  return normalizedSettings
}

export const shouldShowTeacherMessageButton = (role, settings) => {
  if ([rolesEnum.admin, rolesEnum.juniorAdmin].includes(role)) return true
  if (role === rolesEnum.children) {
    return !settings.disableMyTeachersMessagesForChildren
  }
  if (role === rolesEnum.parent) {
    return !settings.disableMyTeachersMessagesForParents
  }

  return !settings.disableMyTeachersMessagesForEmployees
}

export const canStartTeacherChatForRole = (role, platformSettings = {}) => {
  if (role === rolesEnum.children) {
    return platformSettings.isChildrenCanStartChat === '1'
  }
  if (role === rolesEnum.parent) {
    return platformSettings.isParentCanStartChat === '1'
  }
  if (role === rolesEnum.seniorSeminarian) {
    return platformSettings.methodistCanInitiateDialoguesAndCreateChats === '1'
  }

  return true
}
